import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Epoca } from 'src/app/models/api/comercial/epoca';

@Injectable({
  providedIn: 'root'
})
export class ApiEpocaService {
  private baseUrl = 'Epoca';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Epoca[]>('');
  }
}
